import React, { useEffect, useRef, useState } from "react";
import ToggleStyle from "./ToggleSwitch.module.css";

const ToggleSwitch = (props) => {
  const toggleRef = useRef();
  const [isExperiencer, setIsExperiencer] = useState(props.isExperiencer);
  useEffect(() => {
    !props.isExperiencer &&
      toggleRef.current.scrollIntoView({ behavior: "smooth" });
  }, []);
  const select = (value) => {
    props.setIsExperiencer(value);
    setIsExperiencer(value);
  };

  return (
    <div ref={toggleRef}>
      <div className={""}>
        {/* Two separate buttons; the highlight behind them slides between the two. */}
        <div
          className={`${ToggleStyle.buttons} ${
            isExperiencer ? "" : ToggleStyle.toLocal
          }`}
        >
          {/*
            Plain buttons, not react-bootstrap's <Button>: its .btn/.btn-primary
            rules (e.g. ":not(.btn-check)+.btn:active") outrank this module's CSS
            and painted a solid background over the sliding fill on click.
          */}
          <button
            type="button"
            aria-pressed={isExperiencer}
            className={`${ToggleStyle.button} ${
              isExperiencer ? ToggleStyle.active : ""
            }`}
            onClick={() => select(true)}
          >
            Experiencer
          </button>
          <button
            type="button"
            aria-pressed={!isExperiencer}
            className={`${ToggleStyle.button} ${
              !isExperiencer ? ToggleStyle.active : ""
            }`}
            onClick={() => select(false)}
          >
            Local
          </button>
        </div>
      </div>
    </div>
  );
};

export default ToggleSwitch;
